goog.provide("shadow.js.shim.module$$mui$material$CardActions");
goog.provide("module$shadow_js_shim_module$$mui$material$CardActions");
shadow.js.shim.module$$mui$material$CardActions = shadow.js.nativeProvides["@mui/material/CardActions"] = shadow$bridge("@mui/material/CardActions");
module$shadow_js_shim_module$$mui$material$CardActions.default = shadow.js.shim.module$$mui$material$CardActions;
